import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Diagnosis } from '../objects/Diagnosis';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';

export class TestTubeScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    correctDiagnosis: Diagnosis;
    testTube: Phaser.GameObjects.Image;

    constructor() {
        super({
            key: "TestTubeScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("test_tube_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_test_tube.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        this.registerEvents();
        initializeInteractiveCursor(this);
    }

    registerEvents(): void {
        // Drag around the blood sample to see through the lense
        this.input.on('drag', (pointer, gameObject, dragX, dragY) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'test_tube_scene_map' });
        this.correctDiagnosis = GameState.current.correctDiagnosis;
    }

    generateScene() {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);

        this.addObjects();
        Helpers.addBackButton(this);
    }

    addObjects(): void {
        var translateString = "Diagnosis.Phaser.TestTubeScene.";
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = TranslateApi.translate(translateString + "text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth / 2 - box.displayWidth / 2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "test_tube") {
                this.testTube = this.add.image(ob.x, ob.y, "assets", "test_tube_green");
                this.testTube.setOrigin(0);
                this.testTube.setDisplaySize(ob.width, ob.height);
                this.testTube.setInteractive();
                this.testTube.on('pointerdown', () => {
                    this.testTube.setAlpha(1);
                    this.tweens.killTweensOf(this.testTube);
                    this.testTube.disableInteractive();
                    this.addReaction();
                });

                Helpers.flashObject(this, this.testTube);
            }
        });
    }

    /**
     * Adds a "reaction" from the test tube using a particle emitter
     */
    addReaction(): void {
        this.tweens.add({
            targets: this.testTube,
            x: this.testTube.x + 25,
            duration: 100,
            ease: Phaser.Math.Easing.Circular,
            repeat: 5,
            yoyo: true,
            onComplete: () => {
                // Start reaction after a little delay
                setTimeout(() => {
                    var reactionAsset = GameState.current.correctDiagnosis.reactionAsset;
                    var reaction = this.add.particles("assets", reactionAsset);
                    var emitter = reaction.createEmitter({
                        x: this.testTube.x + this.testTube.displayWidth / 2,
                        y: this.testTube.getTopLeft().y,
                        scale: { start: 0.3, end: 0.4 },
                        angle: { min: 200, max: 330 },
                        speed: 100,
                        lifespan: 1200,
                        blendMode: Phaser.BlendModes.SCREEN,
                    });
                    Helpers.addNextButton(this);
                }, 900);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/TestTubeScene.ts